import { render, staticRenderFns } from "./VehicleLayoutPreview.vue?vue&type=template&id=857dbb08"
import script from "./VehicleLayoutPreview.vue?vue&type=script&lang=js"
export * from "./VehicleLayoutPreview.vue?vue&type=script&lang=js"
import style0 from "./VehicleLayoutPreview.vue?vue&type=style&index=0&id=857dbb08&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports